import React, { useRef } from 'react';

const StoryboardConverterControls = ({ config, onChange }) => {
  const fileInputRef = useRef(null);

  const handleChange = (key, value) => {
    onChange({ [key]: value });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.storyboard')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleChange('storyboardContent', e.target.result);
      };
      reader.readAsText(file);
    } else {
      alert('Please upload a .storyboard file');
    }
  };

  const handlePaste = () => {
    navigator.clipboard.readText().then(text => {
      handleChange('storyboardContent', text);
    });
  };

  return (
    <div className="space-y-6">
      {/* File Upload */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Upload Storyboard File
        </label>
        <div className="flex gap-2">
          <input
            ref={fileInputRef}
            type="file"
            accept=".storyboard"
            onChange={handleFileUpload}
            className="hidden"
          />
          <button
            onClick={() => fileInputRef.current?.click()}
            className="px-4 py-2 bg-gradient-primary bg-gradient-primary-hover rounded text-white text-sm"
          >
            Choose File
          </button>
          <button
            onClick={handlePaste}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded text-gray-700 dark:text-gray-300 text-sm"
          >
            Paste XML
          </button>
        </div>
        {config.storyboardContent && (
          <p className="mt-2 text-xs text-green-700 dark:text-green-400">
            ✓ Storyboard loaded ({config.storyboardContent.length} characters)
          </p>
        )}
      </div>

      {/* Manual Input */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Or Paste Storyboard XML
        </label>
        <textarea
          value={config.storyboardContent}
          onChange={(e) => handleChange('storyboardContent', e.target.value)}
          rows={12}
          className="w-full px-3 py-2 bg-gray-800 rounded text-white text-sm font-mono resize-none border border-gray-600"
          placeholder="Paste your storyboard XML content here..."
        />
      </div>

      {/* Info */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded p-4">
        <p className="text-sm text-blue-800 dark:text-blue-300">
          <strong>Note:</strong> This converter analyzes storyboard XML and generates equivalent SwiftUI code.
          It converts UIButtons → Button, UILabels → Text, UIImageView → Image, etc.
        </p>
      </div>
    </div>
  );
};

export default StoryboardConverterControls;

